import { SR_API_ACTION_INSURANCE_POLICY_GET_UPLOAD_URL } from 'api/utilityActionTypes';

export default async function getUploadUrl({ state, utilityApiClient }, { fileName, mediaType, size }) {
  return utilityApiClient.postWithState({
    action: SR_API_ACTION_INSURANCE_POLICY_GET_UPLOAD_URL,
    state,
    queryId: `insurance-policy-upload-url-${fileName}`,
    payload: {
      fileName,
      mediaType,
      size,
    },
  });
}
